export default __webpack_public_path__ + "static/media/rambouillet22.3095d869.jpg";